/* FF360 Brand JS v1.2 — additive only.
   1. Rotates the offer bar messages on small screens.
   2. Adds a "NN% OFF" badge to any price list that has a compare-at price.
   3. Adds a WhatsApp icon to the footer social row and makes the footer
      phone number and email tappable.
   Never removes or rewrites existing theme markup. */
(function () {
  'use strict';

  function cfg() {
    var bar = document.querySelector('[data-ff-bar]');
    return {
      wa: bar ? (bar.getAttribute('data-ff-whatsapp') || '') : '',
      waText: bar ? (bar.getAttribute('data-ff-whatsapp-text') || '') : '',
      phone: bar ? (bar.getAttribute('data-ff-phone') || '') : ''
    };
  }

  /* ---------- 1. Offer bar rotation (mobile) ---------- */
  function offerBar() {
    document.querySelectorAll('[data-ff-bar]').forEach(function (bar) {
      var items = bar.querySelectorAll('.ff-bar__item');
      if (items.length < 2) return;
      var i = 0;
      items[0].classList.add('is-on');
      setInterval(function () {
        if (window.matchMedia('(min-width:900px)').matches) return;
        items[i].classList.remove('is-on');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
      }, 3800);
    });
  }

  /* ---------- 2. Discount badge ---------- */
  var CURRENT = 'sale-price, .price:not(.price--compare), .price-item--sale';
  var COMPARE = 'compare-at-price, .price--compare, .price-item--regular, s, del';

  function toNumber(el) {
    if (!el) return null;
    var txt = el.textContent || '';
    var sr = el.querySelector('.sr-only, .visually-hidden');
    if (sr) txt = txt.replace(sr.textContent, '');
    var m = txt.replace(/[^0-9.,]/g, '').match(/([0-9][0-9.,]*)/);
    if (!m) return null;
    var n = parseFloat(m[1].replace(/,/g, ''));
    return isFinite(n) && n > 0 ? n : null;
  }

  function badgeFor(scope) {
    scope.querySelectorAll('.price-list, price-list').forEach(function (list) {
      if (list.querySelector(':scope > .ff-off')) return;
      var compare = list.querySelector(COMPARE);
      var current = list.querySelector(CURRENT);
      if (!compare || !current || compare === current) return;
      var was = toNumber(compare);
      var now = toNumber(current);
      if (!was || !now || was <= now) return;
      var pct = Math.round(((was - now) / was) * 100);
      if (pct < 3 || pct > 95) return;
      var tag = document.createElement('span');
      tag.className = 'ff-off';
      tag.setAttribute('aria-label', pct + ' percent off');
      tag.textContent = pct + '% OFF';
      list.appendChild(tag);
    });
  }

  /* ---------- 3. WhatsApp in the footer ---------- */
  var WA_PATH = 'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 0 1 6.988 2.896 9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z';

  function addWhatsApp() {
    var c = cfg();
    if (!c.wa) return;

    document.querySelectorAll('.social-media').forEach(function (list) {
      if (list.querySelector('.ff-wa-item')) return;

      var href = 'https://wa.me/' + c.wa +
        (c.waText ? '?text=' + encodeURIComponent(c.waText) : '');

      var li = document.createElement('li');
      li.className = 'social-media__item ff-wa-item';

      var a = document.createElement('a');
      a.className = 'tap-area ff-wa-link';
      a.href = href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label', 'Chat with us on WhatsApp');

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '24');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('class', 'icon icon-whatsapp');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', WA_PATH);
      p.setAttribute('fill', 'currentColor');
      svg.appendChild(p);

      a.appendChild(svg);
      li.appendChild(a);
      list.appendChild(li);
    });
  }

  /* Make the footer phone number and email tappable, without rewriting the block */
  function linkifyContact() {
    var c = cfg();
    document.querySelectorAll('.footer__block--text').forEach(function (block) {
      block.querySelectorAll('h5').forEach(function (h) {
        if (h.querySelector('a')) return;
        var txt = (h.textContent || '').trim();
        if (!txt) return;

        var href = null;
        if (txt.indexOf('@') > -1) {
          href = 'mailto:' + txt;
        } else if ((txt.replace(/\D/g, '') || '').length >= 8) {
          href = 'tel:' + (c.phone || txt.replace(/\D/g, ''));
        }
        if (!href) return;

        var a = document.createElement('a');
        a.href = href;
        a.className = 'ff-contact-link';
        while (h.firstChild) a.appendChild(h.firstChild);
        h.appendChild(a);
      });
    });
  }

  function run() {
    try { badgeFor(document); } catch (e) {}
    try { addWhatsApp(); } catch (e) {}
    try { linkifyContact(); } catch (e) {}
  }

  function init() {
    offerBar();
    run();
    var pending = null;
    var mo = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(run, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
